import { render, staticRenderFns } from "./DatetimeAgo.vue?vue&type=template&id=0275c346"
import script from "./DatetimeAgo.vue?vue&type=script&lang=js"
export * from "./DatetimeAgo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports